<template>
  <div class="shuiji">
    <div class="onebox">
      <div class="title">
        <titleCard :title="title"></titleCard>
      </div>
      <p class="tishi">
        70% + Water Recovery Rate / Water Bacterial Colonies ＜10CFU/ml /
        Endotoxin ＜0.03EU/ml
      </p>
      <p class="tishiios">
        70% + Water Recovery Rate / Water Bacterial Colonies ＜10CFU/ml /
        Endotoxin ＜0.03EU/ml
      </p>
      <div class="header">
        <div class="left">
          <h4>Hemodialyis and Water Treatment Equipment</h4>
          <ul>
            <li
              class="animate__animated wow animate__fadeInLeft"
              data-wow-duration="0.8s"
            >
              <div class="icon icon1"></div>
              <p>
                Class II Medical Devices, for the preparation of hemodialysis
                and related treatment water in medical institutions.
              </p>
            </li>
            <li
              class="animate__animated wow animate__fadeInLeft"
              data-wow-duration="1.2s"
            >
              <div class="icon icon2"></div>
              <p>Patients are exposed to up to 600L of dialysate per week.</p>
            </li>
            <li
              class="animate__animated wow animate__fadeInLeft"
              data-wow-duration="1.6s"
            >
              <div class="icon icon3"></div>
              <p>
                Trace amounts of harmful substances and bacteria in the dialysis
                water cause short-term and long-term harm to patients.
              </p>
            </li>
            <li
              class="animate__animated wow animate__fadeInLeft"
              data-wow-duration="2.0s"
            >
              <div class="icon icon4"></div>
              <p>
                The quality of dialysis water is critical to the quality of
                dialysis and needs to be purified.
              </p>
            </li>
          </ul>
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/Industry/water.webp" alt="" />
        </div>
      </div>
      <div class="header-ios">
        <div class="right animate__animated wow animate__fadeInUp">
          <img src="../../assets/image/Industry/water.webp" alt="" />
        </div>
        <div class="left">
          <h4>Hemodialyis and Water Treatment Equipment</h4>
          <ul>
            <li
              class="animate__animated wow animate__fadeInUp"
              data-wow-duration="0.8s"
            >
              <div class="icon icon1"></div>
              <p>
                Class II Medical Devices, for the preparation of hemodialysis
                and related treatment water in medical institutions.
              </p>
            </li>
            <li
              class="animate__animated wow animate__fadeInUp"
              data-wow-duration="1.2s"
            >
              <div class="icon icon2"></div>
              <p>Patients are exposed to up to 600L of dialysate per week.</p>
            </li>
            <li
              class="animate__animated wow animate__fadeInUp"
              data-wow-duration="1.6s"
            >
              <div class="icon icon3"></div>
              <p>
                Trace amounts of harmful substances and bacteria in the dialysis
                water cause short-term and long-term harm to patients.
              </p>
            </li>
            <li
              class="animate__animated wow animate__fadeInUp"
              data-wow-duration="2.0s"
            >
              <div class="icon icon4"></div>
              <p>
                The quality of dialysis water is critical to the quality of
                dialysis and needs to be purified.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="content-box">
          <div class="picbox animate__animated wow animate__fadeInLeft">
            <div class="pic">
              <img src="../../assets/image/Industry/water1.webp" />
            </div>
            <p>专利产品：ZL 202022168538.7</p>
          </div>
          <div class="txtbox animate__animated wow animate__fadeInRight">
            <div class="title">
              <button>Universal Model</button>
              The Series of “Zhi Shan”
            </div>
            <ul>
              <li>
                <span></span> sanitary 316L stainless steel dead-space free
                membrane shell
              </li>
              <li>
                <span></span> self-developed high-efficiency electromagnetic
                heating device
              </li>
              <li>
                <span></span> pressurization systems are equipped with frequency
                conversion slow start technology
              </li>
              <li>
                <span></span> whole machine 85℃ film thermal disinfection + pipe
                121℃ thermal disinfection
              </li>
              <li>
                <span></span> Innovative N + N arrangement for primary and
                secondary reverse osmosis membrane groups
              </li>
            </ul>
          </div>
        </div>
        <div class="content-box bgcolor1">
          <div class="txtbox animate__animated wow animate__fadeInLeft">
            <div class="title">
              <button>Universal Model</button>
              The Series of “Zhi Jing”
            </div>
            <ul>
              <li><span></span> innovative ultra-silence technology ≤40 dB</li>
              <li><span></span> tankless design</li>
              <li>
                <span></span> automatic frequency conversion water supply system
              </li>
              <li><span></span> flexible water recovery device</li>
              <li><span></span> ultra-high pipe flow rate design 0.4 m/s</li>
            </ul>
          </div>
          <div
            class="picbox picbox2 animate__animated wow animate__fadeInRight"
          >
            <div class="pic pic2">
              <img src="../../assets/image/Industry/water2.webp" />
            </div>
            <p>专利产品：ZL 202021916717.8</p>
          </div>
        </div>
        <div class="content-box content-box2">
          <div class="picbox animate__animated wow animate__fadeInLeft">
            <div class="pic pic3">
              <img src="../../assets/image/Industry/water3.webp" />
            </div>
          </div>
          <div class="txtbox animate__animated wow animate__fadeInRight">
            <div class="title">
              <button>Universal Model</button>
              The Series of “New Standard”
            </div>
            <ul>
              <li>
                <span></span> intelligent touch technology, dead space-free
                superconducting DC design
              </li>
              <li>
                <span></span> automatic intelligent integrated frequency
                conversion water supply system
              </li>
              <li>
                <span></span> automatic sandfilter tank / activated-charcoal
                tank / softener
              </li>
              <li>
                <span></span> pipe stainless steel 316L, spin welding, mirror
                polishing
              </li>
            </ul>
          </div>
        </div>
        <div class="content-box content-box3">
          <div class="txtbox animate__animated wow animate__fadeInLeft">
            <div class="title">121℃ high temperature disinfection device</div>
            <ul>
              <li>
                <span></span> UPS non-contact thermodynamic design, no secondary
                contamination
              </li>
              <li>
                <span></span> no heating water tank, save water and electricity
                by 60%
              </li>
              <li>
                <span></span> temperature control device to avoid high
                temperature waste discharge
              </li>
            </ul>
          </div>
          <div
            class="picbox picbox2 animate__animated wow animate__fadeInRight"
          >
            <div class="pic pic4">
              <img src="../../assets/image/Industry/water4.webp" />
            </div>
          </div>
        </div>
        <div class="content-box content-box4">
          <div class="picbox animate__animated wow animate__fadeInLeft">
            <div class="pic pic5">
              <img src="../../assets/image/Industry/water5.webp" />
            </div>
          </div>
          <div class="txtbox animate__animated wow animate__fadeInRight">
            <div class="title">dead space-free minor-cycle assembly</div>
            <ul>
              <li>
                dual circuit circulation system <br />316L stainless steel lined
                with PTFE<br />self-locking joint
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main-ios">
        <div class="content-box animate__animated wow animate__fadeInUp">
          <div class="txtbox">
            <div class="title">
              <button>Universal Model</button>
              The Series of “Zhi Shan”
            </div>
            <ul>
              <li>
                <span></span> sanitary 316L stainless steel dead-space free
                membrane shell
              </li>
              <li>
                <span></span> self-developed high-efficiency electromagnetic
                heating device
              </li>
              <li>
                <span></span> pressurization systems are equipped with frequency
                conversion slow start technology
              </li>
              <li>
                <span></span> whole machine 85℃ film thermal disinfection + pipe
                121℃ thermal disinfection
              </li>
              <li>
                <span></span> Innovative N + N arrangement for primary and
                secondary reverse osmosis membrane groups
              </li>
            </ul>
          </div>
          <div class="picbox">
            <div class="pic">
              <img src="../../assets/image/Industry/water1.webp" />
            </div>
            <p>专利产品：ZL 202022168538.7</p>
          </div>
        </div>
        <div
          class="content-box bgcolor1 animate__animated wow animate__fadeInUp"
        >
          <div class="txtbox">
            <div class="title">
              <button>Universal Model</button>
             The Series of “Zhi Jing”
            </div>
            <ul>
              <li><span></span> innovative ultra-silence technology ≤40 dB</li>
              <li><span></span> tankless design</li>
              <li><span></span> automatic frequency conversion water supply system</li>
              <li><span></span> flexible water recovery device</li>
              <li><span></span> ultra-high pipe flow rate design 0.4 m/s</li>
            </ul>
          </div>
          <div class="picbox picbox2">
            <div class="pic pic2">
              <img src="../../assets/image/Industry/water2.webp" />
            </div>
            <p>专利产品：ZL 202021916717.8</p>
          </div>
        </div>
        <div class="content-box animate__animated wow animate__fadeInUp">
          <div class="txtbox">
            <div class="title">
              <button>Universal Model</button>
              The Series of “New Standard”
            </div>
            <ul>
              <li><span></span> intelligent touch technology, dead space-free
                superconducting DC design</li>
              <li><span></span> automatic intelligent integrated frequency
                conversion water supply system</li>
              <li><span></span> automatic sandfilter tank / activated-charcoal
                tank / softener</li>
              <li>
                <span></span> pipe stainless steel 316L, spin welding, mirror
                polishing
              </li>
            </ul>
          </div>
          <div class="picbox">
            <div class="pic pic3">
              <img src="../../assets/image/Industry/water3.webp" />
            </div>
          </div>
        </div>
        <div
          class="content-box content-box3 animate__animated wow animate__fadeInUp"
        >
          <div class="txtbox">
            <div class="title">121℃ high temperature disinfection device</div>
            <ul>
              <li><span></span> UPS non-contact thermodynamic design, no secondary
                contamination</li>
              <li><span></span> no heating water tank, save water and electricity
                by 60%</li>
              <li><span></span> temperature control device to avoid high
                temperature waste discharge</li>
            </ul>
          </div>
          <div class="picbox picbox2">
            <div class="pic pic4">
              <img src="../../assets/image/Industry/water4.webp" />
            </div>
          </div>
        </div>
        <div
          class="content-box content-box4 animate__animated wow animate__fadeInUp"
        >
          <div class="txtbox">
            <div class="title">dead space-free minor-cycle assembly</div>
            <ul>
              <li>
                 dual circuit circulation system <br />316L stainless steel lined
                with PTFE<br />self-locking joint
              </li>
            </ul>
          </div>
          <div class="picbox">
            <div class="pic pic5">
              <img src="../../assets/image/Industry/water5.webp" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="twobox animate__animated wow animate__fadeInUp">
      <div class="title">
        <div class="titleCard">
          <p>Dialysis Water Treatment System</p>
          <span></span>
        </div>
      </div>
      <p class="titletxt">Integration of IoT technology</p>
      <div class="content">
        <div class="content-left">
          <div class="card">
            <div class="icon">
              <img src="../../assets/image/Industry/watericon5.webp" alt="" />
            </div>
            <p>scan QR code for data traceability and machine repair</p>
          </div>
          <div class="card">
            <div class="icon">
              <img src="../../assets/image/Industry/watericon6.webp" alt="" />
            </div>
            <p>automatic upload of daily records</p>
          </div>
          <div class="card">
            <div class="icon">
              <img src="../../assets/image/Industry/watericon7.webp" alt="" />
            </div>
            <p>Wechat code scanning one key warranty</p>
          </div>
          <div class="card">
            <div class="icon">
              <img src="../../assets/image/Industry/watericon8.webp" alt="" />
            </div>
            <p>intelligent warning of consumables renewal</p>
          </div>
        </div>
        <div class="content-right"></div>
      </div>
    </div>
    <div class="threebox animate__animated wow animate__fadeIn">
      <div class="title">
        <titleCard title="Installation photos"></titleCard>
      </div>
      <p class="titletext">
        higher standards for quality products and professional services
      </p>
      <div class="cards">
        <div class="card">
          <div class="picbox">
            <img src="../../assets/image/Industry/water6.webp" alt="" />
            <div class="name">
              <p>Beijing Jishuitan Hospital</p>
            </div>
          </div>
          <div class="txtbox">【Zhi shan scene】</div>
        </div>
        <div class="card">
          <div class="picbox">
            <img src="../../assets/image/Industry/water7.webp" alt="" />
            <div class="name">
              <p>Liberation Army Air Force General Hospital</p>
            </div>
          </div>
          <div class="txtbox">【Zhi shan scene】</div>
        </div>
        <div class="card">
          <div class="picbox">
            <img src="../../assets/image/Industry/water8.webp" alt="" />
            <div class="name">
              <p>ZIBO FIRST HOSPITAL</p>
            </div>
          </div>
          <div class="txtbox">【Zhi Jing scene】</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleCard from "@/components/title-card.vue";
export default {
  data() {
    return {
      title: "Hemodialysis Water Treatment Equipment",
    };
  },
  components: {
    titleCard,
  },
  created() {
    if (document.body.clientWidth < 540) {
      this.title = "Hemodialysis Water Treatment Equipment";
    }
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.shuiji {
  .onebox {
    .title {
      padding: 1.0211rem 0 0.6105rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 33px 0;
      }
    }
    .tishi {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
    .tishiios {
      display: none;
      color: #272b2d;
      font-size: 15px;
      text-align: center;
      line-height: 25px;
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
    .header-ios {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      margin-top: 20px;
      .right {
        width: 100%;
        box-sizing: border-box;
        padding: 0 67px;
        height: 270px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .left {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        margin: 42px 0;
        h4 {
          margin: 0;
          color: #272b2d;
          font-size: 16px;
          margin-bottom: 15px;
          text-align: center;
        }
        ul {
          li {
            cursor: pointer;
            margin-bottom: 10px;
            width: 100%;
            height: 60px;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            background-color: #ffffff;
            color: #333333;
            .icon {
              width: 17px;
              height: 17px;
              margin: 0 18px;
            }
            p {
              flex: 1;
            }
            .icon1 {
              background: url("../../assets/image/Industry/watericon1.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            .icon2 {
              background: url("../../assets/image/Industry/watericon2.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            .icon3 {
              background: url("../../assets/image/Industry/watericon3.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            .icon4 {
              background: url("../../assets/image/Industry/watericon4.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            p {
              font-size: 14px;
              // padding-right: 18px;
              width: 80%;
            }
          }
          li:hover {
            background-color: #0ca6eb;
            color: #fff;
          }
          :nth-child(1):hover .icon1 {
            background: url("../../assets/image/Industry/watericon1-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
          :nth-child(2):hover .icon2 {
            background: url("../../assets/image/Industry/watericon2-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
          :nth-child(3):hover .icon3 {
            background: url("../../assets/image/Industry/watericon3-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
          :nth-child(4):hover .icon4 {
            background: url("../../assets/image/Industry/watericon4-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .header {
      padding: 1.2632rem 0 1.1158rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .left {
        width: 8.2947rem;
        h4 {
          margin: 0;
          color: #272b2d;
          font-size: 0.2947rem;
          margin-bottom: 0.2947rem;
        }
        ul {
          li {
            cursor: pointer;
            margin-bottom: 0.2105rem;
            width: 100%;
            height: 1.2632rem;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            background-color: #ffffff;
            color: #333333;
            .icon {
              width: 0.3579rem;
              height: 0.3579rem;
              margin: 0 0.3789rem;
            }
            .icon1 {
              background: url("../../assets/image/Industry/watericon1.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            .icon2 {
              background: url("../../assets/image/Industry/watericon2.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            .icon3 {
              background: url("../../assets/image/Industry/watericon3.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            .icon4 {
              background: url("../../assets/image/Industry/watericon4.webp")
                no-repeat;
              background-size: 100% 100%;
            }
            p {
              font-size: 0.2421rem;
            }
          }
          li:hover {
            background-color: #0ca6eb;
            color: #fff;
          }
          :nth-child(1):hover .icon1 {
            background: url("../../assets/image/Industry/watericon1-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
          :nth-child(2):hover .icon2 {
            background: url("../../assets/image/Industry/watericon2-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
          :nth-child(3):hover .icon3 {
            background: url("../../assets/image/Industry/watericon3-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
          :nth-child(4):hover .icon4 {
            background: url("../../assets/image/Industry/watericon4-hover.webp")
              no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .right {
        margin-left: 1.3684rem;
        height: 5.6842rem;
        width: 5.7895rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .main-ios {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .bgcolor1 {
        background-color: #fff !important;
      }
      .content-box2 {
        height: 8.5263rem !important;
      }
      .content-box {
        background-color: #fbfbfb;
        padding: 0 28px;
        .picbox {
          .pic {
            width: 6.7579rem;
            height: 4.7158rem;
            @media screen and (max-width: 540px) {
              height: 220px;
              width: 100%;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
          .pic2 {
            height: 220px;
            width: 100%;
          }
          .pic3 {
            height: 220px;
            width: 100%;
            margin-bottom: 22px;
          }
          .pic4 {
            height: 220px;
            width: 100%;
          }
          .pic5 {
            height: 220px;
            width: 100%;
            margin-bottom: 22px;
          }
          p {
            color: #999999;
            font-size: 0.2526rem;
            text-align: center;
            @media screen and (max-width: 540px) {
              font-size: 13px;
              padding-bottom: 34px;
            }
          }
        }
        .txtbox {
          .title {
            margin-bottom: 1.0526rem;
            padding: 0;
            color: #039ff0;
            font-size: 20px;
            font-weight: 700;
            padding-top: 40px;
            display: flex;
            align-items: center;
            text-align: center;
            button {
              width: 107px;
              height: 43px;
              background: #0ca6eb;
              border: none;
              color: #fff;
              font-size: 19px;
              list-style: none;
            }
          }
          ul {
            li {
              display: flex;
              align-items: center;
              font-size: 15px;
              color: #666666;
              margin-bottom: 22px;
              span {
                display: block;
                width: 9px;
                height: 9px;
                background: #666666;
                margin-right: 12px;
                border-radius: 50%;
              }
            }
          }
        }
      }
      .content-box3 {
        background-color: #bebec0;
        .title {
          text-align: left !important;
          color: #ffffff !important;
        }
        ul {
          li {
            color: #ffffff !important;
            span {
              background-color: #fff !important;
            }
          }
        }
      }
      .content-box4 {
        .title {
          text-align: left !important;
        }
      }
    }
    .main {
      @media screen and (max-width: 540px) {
        display: none;
      }
      .bgcolor1 {
        background-color: #fff !important;
      }
      .content-box2 {
        height: 8.5263rem !important;
      }
      .content-box {
        height: 9.0526rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fbfbfb;
        .picbox2 {
          margin-left: 1.2105rem;
        }

        .picbox {
          flex: 1;
          .pic {
            width: 6.7579rem;
            height: 4.7158rem;
            margin: auto;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .pic2 {
            width: 9.3368rem;
            height: 6.2316rem;
          }
          .pic3 {
            width: 6.0842rem;
            height: 5.5263rem;
          }
          .pic4 {
            width: 8.7368rem;
            height: 5.1579rem;
          }
          .pic5 {
            width: 4.4rem;
            height: 3.2421rem;
          }
          p {
            color: #999999;
            font-size: 0.2526rem;
            text-align: center;
          }
        }
        .txtbox {
          margin-left: 0.6842rem;
          padding: 0 1rem;
          flex: 1;
          .title {
            margin-bottom: 1.0526rem;
            padding: 0;
            color: #039ff0;
            font-size: 0.3789rem;
            display: flex;
            align-items: center;
            font-weight: 700;
            button {
              width: 1.7263rem;
              height: 0.6947rem;
              background: #0ca6eb;
              margin-right: 20px;
              padding: 5px 10px;
              border: none;
              color: #fff;
              font-size: 0.2558rem;
              list-style: none;
            }
          }
          ul {
            li {
              display: flex;
              align-items: center;
              font-size: 0.2526rem;
              color: #666666;
              margin-bottom: 0.3368rem;
              span {
                display: block;
                width: 0.1474rem;
                height: 0.1474rem;
                background: #666666;
                margin-right: 0.2rem;
                border-radius: 50%;
              }
            }
          }
        }
      }
      .content-box3 {
        height: 7.7895rem !important;
        background-color: #bebec0;
        .title {
          margin-bottom: 0.6737rem !important;
          color: #fff !important;
        }
        ul {
          li {
            color: #fff !important;
          }
          span {
            background-color: #fff !important;
          }
        }
      }
      .content-box4 {
        height: 6.4211rem;
        .txtbox {
          .title {
            margin-bottom: 0.5263rem !important;
          }
          ul {
            li {
              line-height: 0.4211rem;
            }
          }
        }
      }
    }
  }
  .twobox {
    height: 9.2632rem;
    width: 100%;
    background: url("../../assets/image/Industry/water-bg.webp") no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 650px;
      background-size: cover;
      background-position: 40% 0;
    }
    .title {
      padding: 0.8105rem 0 0.4211rem 0;
      @media screen and (max-width: 540px) {
        padding: 38px 0 18px 0;
      }
      .titleCard {
        text-align: center;
        p {
          padding-bottom: 0.3789rem;
          font-size: 0.4421rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.0526rem;
          @media screen and (max-width: 540px) {
            font-size: 21px;
          }
        }
        span {
          margin: 0 auto;
          position: relative;
          display: block;
          width: 3.0947rem;
          height: 0.0421rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 150px;
            height: 2px;
          }
        }
        span::after {
          content: "";
          position: absolute;
          left: 50%;
          margin-left: -0.2947rem;
          bottom: -0.0105rem;
          width: 0.5895rem;
          height: 0.0842rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            height: 4px;
            bottom: -1px;
          }
        }
      }
    }
    .titletxt {
      color: #ffffff;
      font-size: 0.2526rem;
      text-align: center;
      padding-bottom: 0.8842rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        padding-bottom: 66px;
      }
    }
    .content {
      height: 4.7684rem;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .content-left {
        width: 5.3158rem;
        @media screen and (max-width: 540px) {
          width: 90%;
          margin: 0 auto;
          display: flex;
          flex-wrap: wrap;
        }
        .card {
          width: 100%;
          display: flex;
          @media screen and (max-width: 540px) {
            width: 50%;
            height: 90px;
            font-size: 14px;
          }
          align-items: center;
          height: 0.9474rem;
          font-size: 0.2247rem;
          color: #ffffff;
          position: relative;
          background: linear-gradient(
            266deg,
            rgba(255, 255, 255, 0) 4%,
            #1ebaff33 97%
          );
          margin: 0.1053rem 0;
          .icon {
            width: 0.5684rem;
            height: 0.5684rem;
            padding: 0 0.2526rem;
            @media screen and (max-width: 540px) {
              width: 27px;
              height: 27px;
              padding: 0 15px;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          p {
            flex: 1;
          }
        }
        .card::after {
          position: absolute;
          content: "";
          left: 0;
          bottom: 0;
          width: 0.0947rem;
          height: 100%;
          background: #1ebaff;
          @media screen and (max-width: 540px) {
            width: 5px;
          }
        }
      }
      .content-right {
        // margin: 0.6rem 0.2105rem 0.7368rem 0.6316rem;
        height: 3.4316rem;
        width: 6.1053rem;
        background: url("../../assets/image/Industry/water-bg2.webp") no-repeat;
        background-size: 100% 100%;
        @media screen and (max-width: 540px) {
          height: 175px;
          width: 70%;
          margin: 0 auto;
          margin-top: 20px;
        }
      }
    }
  }
  .threebox {
    .title {
      padding: 1.0947rem 0 0.3789rem 0;
      @media screen and (max-width: 540px) {
        padding: 52px 0 15px 0;
      }
    }
    .titletext {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding-bottom: 1.4737rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
      }
    }
    .cards::-webkit-scrollbar {
      display: none;
    }
    .cards {
      display: flex;
      justify-content: space-between;
      margin-bottom: 1.0526rem;
      margin: 0 6px;
      overflow: scroll;
      overflow-y: hidden;
      .card {
        width: 6.4211rem;
        @media screen and (max-width: 540px) {
          flex-basis: 300px;
          flex-shrink: 0;
          margin: 0 6px;
        }
        .picbox {
          height: 3.3158rem;
          @media screen and (max-width: 540px) {
            height: 157px;
          }
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .name {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 0.5263rem;
            display: flex;
            @media screen and (max-width: 540px) {
              height: 25px;
            }
            align-items: center;
            justify-content: flex-end;
            p {
              padding-right: 0.2842rem;
              @media screen and (max-width: 540px) {
                font-size: 12px;
              }
            }
            width: 100%;
            font-size: 0.1895rem;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.2);
          }
        }
        .txtbox {
          padding: 0.4211rem 0;
          text-align: center;
          color: #999999;
          font-size: 0.2526rem;
          font-weight: 500;
          @media screen and (max-width: 540px) {
            padding: 20px 0;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
